// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__16w9e","container":"styles_container__33Eo3","title":"styles_title__1aLQz","wrapper":"styles_wrapper__1KcmG","answer":"styles_answer__3r17W"};